import { inject, Injectable } from '@angular/core';
import { BadgeConfig, MilestoneStage, StageStatus } from '@models';
import { CommonFunctionsService } from '@services';

@Injectable({
  providedIn: 'root'
})
export class StageTooltipService {
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);

  buildHTML(stage: MilestoneStage): string {
    return `
      <div class="study-gantt-chart-tooltip-container">
        <h3 class="study-gantt-chart-tooltip-title">${this.commonFunctionsService.toSentenceCase(stage.stage)}</h3>
        <div class="study-gantt-chart-tooltip-contents">
          ${this.getStageStatusHTML(stage.status)}
        <p class="study-gantt-chart-tooltip-item">
          <span class="study-gantt-chart-tooltip-label">Start date</span>
          <span class="study-gantt-chart-tooltip-value">Baseline: ${this.commonFunctionsService.formatDate(stage.startDates.baseline)}</span>
          <span class="study-gantt-chart-tooltip-value">Planned: ${this.commonFunctionsService.formatDate(stage.startDates.planned)}</span>
          <span class="study-gantt-chart-tooltip-value">Actual: ${this.commonFunctionsService.formatDate(stage.startDates.actual)}</span>

        </p>
        <p class="study-gantt-chart-tooltip-item">
          <span class="study-gantt-chart-tooltip-label">End date</span>
          <span class="study-gantt-chart-tooltip-value">Baseline: ${this.commonFunctionsService.formatDate(stage.endDates.baseline)}</span>
          <span class="study-gantt-chart-tooltip-value">Planned: ${this.commonFunctionsService.formatDate(stage.endDates.planned)}</span>
          <span class="study-gantt-chart-tooltip-value">Actual: ${this.commonFunctionsService.formatDate(stage.endDates.actual)}</span>
          </p>
        <p class="study-gantt-chart-tooltip-item">
          <span class="study-gantt-chart-tooltip-value">
            <span class="study-gantt-chart-tooltip-highlight-value">Total duration: </span> 
            ${this.getFormattedTotalDuration(stage.totalDuration)}
          </span>
        </p>
        </div>
      </div>
    `;
  }

  getStageStatusHTML(stageStatus: StageStatus) {
    const badge = this.getStageBadge(stageStatus);

    return `
        
     <div class="study-gantt-chart-tooltip-status-item">
        <span class="study-gantt-chart-tooltip-label">Status:</span>
        <core-badge 
          color="${badge.textColor}" 
          backgroundcolor="${badge.backgroundColor ?? ''}" 
          label="${badge.label}" 
          showicon="true"
        >
          <img slot="icon" src="assets/icons/statuses/muted/${badge.icon}" alt="${badge.label} icon"/>
        </core-badge>
      </div>`;
  }

  private getStageBadge(stageStatus: StageStatus): BadgeConfig {
    const badgeMap: Record<string, BadgeConfig> = {
      Complete: {
        label: 'Completed',
        textColor: '#00399C',
        backgroundColor: '#DFEEFF',
        icon: 'completed.svg',
        iconColor: null
      },
      'In Progress': {
        label: 'In progress',
        textColor: '#005512',
        backgroundColor: '#D9FBE2',
        icon: 'on-track.svg',
        iconColor: null
      },
      Upcoming: {
        label: 'Upcoming',
        textColor: 'gray',
        backgroundColor: null,
        icon: 'upcoming.svg',
        iconColor: null
      }
    };

    return stageStatus ? badgeMap[stageStatus] : badgeMap['Upcoming'];
  }

  private getFormattedTotalDuration(totalDuration: number | null): string {
    if (totalDuration === null) {
      return '--';
    }
    const daysLabel = totalDuration === 1 ? 'day' : 'days';

    return `${totalDuration} ${daysLabel}`;
  }
}
